export default function parsePosts(posts: any) {
    return posts.sort((a: any, b: any) => {
        const [aM, aS, aP] = a.order;
        const [bM, bS, bP] = b.order;
        if (aM > bM) return 1;
        if (aM < bM) return -1;
        if (aS > bS) return 1;
        if (aS < bS) return -1;
        if (aP > bP) return 1;
        if (aP < bP) return -1;
        return 0;
    });
}
